<!--<div style="height: 70px;">
    <app-spinner *ngIf="isLoading" style="position: relative; top: 10px;"></app-spinner>
</div>-->

<div *ngIf="isLoading">
    <ng-container *ngIf="isPRW === undefined; else prwSkeletonDap">
        <app-category-skeleton></app-category-skeleton>
    </ng-container>
    <ng-template #prwSkeletonDap>
        <app-spinner></app-spinner>
    </ng-template>
</div>

<div *ngIf="!isLoading">
    <ng-container *ngIf="isPRW === undefined; else prwContentDap">
        <app-category-top-details [categoriesdetails]="topCategoryData" [categoryFilters]="categoryFilters" [subCategoriesCount]="subCategoriesCount" [subProductsCount]="subProductsCount" [universalProductsCount]="universalProductsCount" (applyFilterEvent)="applyFilter($event)"
            (applyShowAllEvent)="applyShowAll()" />

        <app-sub-category [subCategories]="subCategories" [subProducts]="subProducts" [universalProducts]="universalProducts" [catProductPromotion]="productPromotion" [name]="name" [category_key]="category_key" [limitSubCategories]="limitSubCategories" [limitSubProducts]="limitSubProducts"
            [hideCategoriesLoadMore]="hideCategoriesLoadMore" [hideProductsLoadMore]="hideProductsLoadMore" (refreshPageEvent)="refreshCategoryPage()" (subCategoriesLoadMore)="loadMoreSubCategories($event)" (subProductsLoadMore)="laodMoreSubProducts($event)"
        />
    </ng-container>
    <ng-template #prwContentDap>
        <app-category-product></app-category-product>
    </ng-template>

    <app-subscribe/>
</div>